import { useEffect, useRef } from "react";

type Args = {
  /** 要素外をクリックした場合に発火する処理 */
  onOutsidePointerDown: () => void;
};

export const useOutsidePointerdown = <T extends Node>({ onOutsidePointerDown }: Args) => {
  const ref = useRef<T>(null);

  const onPointerdown = (event: PointerEvent) => {
    if (!ref.current || ref.current.contains(event.target as Node)) return;
    onOutsidePointerDown();
  };

  useEffect(() => {
    document.addEventListener("pointerdown", onPointerdown, { passive: true });

    return () => {
      document.removeEventListener("pointerdown", onPointerdown);
    };
  }, [onOutsidePointerDown]);

  return { ref };
};
